import { render } from "./RangeBar.vue?vue&type=template&id=0ffc4e8c"
import script from "./RangeBar.vue?vue&type=script&lang=js"
export * from "./RangeBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__